import { useListState } from '@mantine/hooks';
import { useEffect, useState } from 'react';
import { CategoryDto } from '../DocumentT';
import { PositionS } from '../PositionS';

// eslint-disable-next-line import/prefer-default-export
export const useProductCategories = () => {
  const [loading, setLoading] = useState(false);
  const [categories, handlers] = useListState<CategoryDto>([]);
  const { setState } = handlers;

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const load = () => {
    setLoading(true);
    PositionS.fetchCategories()
      .then(setState)
      .finally(() => setLoading(false));
  };

  return { loading, refresh: load, categories, handlers };
};
